import { render } from "./help.vue?vue&type=template&id=12529987"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"

import "./help.vue?vue&type=style&index=0&id=12529987&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__